
import WebFont from 'webfontloader'

const options = {"families":["Spoqa Han Sans Neo"],"custom":{"urls":[".\u002Fcss\u002FNotoSansKR.css"]}}

WebFont.load(options)
